export default {
  state: {
    resourcePage: 0
  },
  mutations: {
    setResourcePage(state, data) {
      state.resourcePage = data;
    }
  },
  getters: {}
};
